import { render } from "./App.vue?vue&type=template&id=e99abf44&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e99abf44&lang=scss"
import "./App.vue?vue&type=style&index=1&id=e99abf44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99abf44"]])

export default __exports__